import * as daHelper from '../dialogActionsHelper';
import {dialogsNames} from '../../../enums/dialogsNames';
import * as spoolsService from '../../../services/Spools/spoolsService';
import Network from 'infrastructure/js/modules/network';
import {api as printLabelsApi} from '../../PrintLabelsActions/printLabelsActions';


const config = {
  getSubmitMethod: () => spoolsService.createSpoolFromCassettes,
};

export const actionTypes = {
  ...daHelper.getActionTypes(dialogsNames.CREATE_SPOOL_FROM_CASSETTES),
};

const actions = {
  ...daHelper.getActions(dialogsNames.CREATE_SPOOL_FROM_CASSETTES),

};

export let api = {
  ...daHelper.getApiActions(actions, config),

  generateSpoolId (dispatch, getState) {
    return function () {
      return spoolsService.generateSpoolId().then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('Generate Spool Id failed', response);
          return { success: false };
        }
        return response.data;
      });
    };
  }
}

export let jsxActions = {
  ...daHelper.getJsxActions(api),

  generateSpoolId() {
    return function (dispatch, getState) {
      return api.generateSpoolId(dispatch, getState)();
    };
  },

  submit(data, messageDialogBuilder, reloadParentComponent, printPDFLabels = false) {
    return function (dispatch, getState) {
      api.submit(dispatch, getState)(data, messageDialogBuilder, reloadParentComponent)
        .then((response) => {

          const { statusType } = response?.applicationResponseStatus ?? {};
          if (statusType === 'OK' && printPDFLabels) {
            const assetId = response.data?.id;
            return printLabelsApi.printMultiAssetsLabels(dispatch, getState)([assetId]);
          }
        })
    };
  },

};
